module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-handshake-5c7336c5f480911d2c2ab0a6154c754c.svg";